export function readWorkingRevision(state: unknown): number {
  if (!state || typeof state !== 'object') {
    return 0;
  }
  const value = (state as { workingRevision?: unknown }).workingRevision;
  return typeof value === 'number' && Number.isFinite(value) ? value : 0;
}
